/**
 * Prompt new users to create a G2MM URL.
 */
define('setup/reserve-g2mm/reserve-g2mm',['require','api-access','../setup-configurator','mixpanel-helper'],function (require) {
    var goToMeetApi = require('api-access').gotomeet;
    var setupConfigurator = require('../setup-configurator');
    var mixpanelHelper = require('mixpanel-helper');

    return function () {
        var self = this;

        self.activate = function () {
            var setupConfig = setupConfigurator.getSetupData();
            var activateRequirement = $.Deferred();

            goToMeetApi.getByUserKey()
                .then(function (g2mmProfile) {
                    self.contentView = {
                        model: 'setup/reserve-g2mm/non-editable/non-editable',
                        activationData: {
                            profileId: g2mmProfile.profileId,
                            nextUrl: setupConfig['reserve-g2mm'].nextUrl
                        }
                    };

                    activateRequirement.resolve();
                })

                .fail(function () {
                    self.contentView = {
                        model: 'setup/reserve-g2mm/editable/editable',
                        activationData: {
                            nextUrl: setupConfig['reserve-g2mm'].nextUrl,
                            freeTrialUser: setupConfig['free-trial'],
                            isG2MMSchedulingTest: setupConfig.isG2MMSchedulingTest
                        }
                    };

                    activateRequirement.resolve();
                });

            self.promoContentView = {
                model: 'setup/reserve-g2mm/promo-steps/promo-steps',
                activationData: {
                    isG2MMSchedulingTest: setupConfig.isG2MMSchedulingTest
                }
            };

            return activateRequirement.promise();
        };

        self.compositionComplete = function () {
            mixpanelHelper.track('Loaded Reserve G2MM page');
        };
    };
});

